<template>
    <div class="zhuanshudingding">
        <div class="banner"></div>
        <div class="cont1">
            <div class="box-cont1">
                <p class="title-box">传统企业办公面临的挑战</p>
                <p class="con-box">× 自研周期长  × 人力成本高  × 技术要求高  × 标准软件不满足个性化需求</p>
                <ul class="ul-box">
                    <li>
                        <img src="./img-info/img-chuanyuan-s1.jpg" alt="" loading="lazy">
                        <p class="pp1">传统业务模式濒临淘汰</p>
                    </li>
                    <li>
                        <img src="./img-info/img-chuanyuan-s2.jpg" alt="" loading="lazy">
                        <p class="pp1">想转型却不知从何入手</p>
                    </li>
                    <li>
                        <img src="./img-info/img-chuanyuan-s3.jpg" alt="" loading="lazy">
                        <p class="pp1">无数字化平台 缺数字化团队</p>
                    </li>
                </ul>
            </div>
            <p class="title-box-x">产品框架</p>
            <div class="jishao">
                <img src="./img-info/img-chuanyuan-s4.jpg" alt="" loading="lazy">
                <div class="right-jiashao">
                    <p class="p-jiashao1">专有钉钉数字化协同平台应用云计算、大数据和移动互联网技术，实现跨层级、跨地域、跨部门、跨业务、跨系统的协同管理和服务。通过结构化的产品支撑体系、业务编排和开放集成能力，构建本地繁荣协同应用生态，支持专有化部署，采取国密加密，安全合规。</p>
                    <p class="changjing">适用场景</p>
                    <p class="one-jiaoshoa">1、助力部委、省、市、县各级政务组织打造协同共治、政企互通的数字化平台，打造高效服务型政府。</p>
                    <p class="one-jiaoshoa">2、快速响应各行业业务领域创新、数字化转型诉求，构建一体化生态数字化沟通和协同平台。</p>
                </div>
            </div>
            <div class="box2-cont1">
                <p class="miderTitle">为什么选择氚云</p>
                <div class="line"></div>
                <p class="letter-title">像搭积木般灵活易用，0基础也能上手</p>
                <ul class="box2-ul">
                    <li>
                        <p class="ps1">灵活配置</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">全行业各业务场景模板买免费提供，安装即用</p>
                        <!-- <p class="ps2">义自己的工作和学习方式，轻松实现千人千面</p> -->
                    </li>
                    <li>
                        <p class="ps1">极速部署</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">积木式搭建企业系统及应用</p>
                        <!-- <p class="ps2">专属数据空间实现业务与数据的分离</p> -->
                    </li>
                    <li>
                        <p class="ps1">集成钉钉</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">PC/移动高效协同，业务流程透明化</p>
                    </li>
                    <li>
                        <p class="ps1">全线打通</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">无缝衔接API接口，互通企业各端数据</p>
                    </li>
                    <li>
                        <p class="ps1">行业方案</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">加速企业实现全链路数字化</p>
                    </li>
                    <li>
                        <p class="ps1">个性定制</p>
                        <p class="lin-yuanjiao"></p>
                        <p class="ps2">低代码/零代码灵活定制满足个性化业务需求</p>
                    </li>


                </ul>

            </div>
        </div>
        <div class="cont2">
            <p class="miderTitles">产品功能</p>
            <ul class="tuijian">
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon1.png" alt="" loading="lazy">
                        <p class="title-hexin">开发者能力</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">支持前后端代码开发、restAPI 、自定义SQL、表单嵌入H5、在线调试等各类功能</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                         <img src="./img-info/img-chuanyuan-icon2.png" alt="" loading="lazy">
                        <p class="title-hexin">表单搭建</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">丰富的字段类型，满足多种填写场景，让企业随心所欲创建表单；强大的数据联动、关联</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon3.png" alt="" loading="lazy">
                        <p class="title-hexin">任务</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">承载任务相关所有信息 减少信息在沟通过程中的失真，场景化沟通，更加透明高效。</p>
                        <p class="p-hexin">填充、子表关联、跨表单数据关联等逻辑规则，在高可用的同时，提供强大的功能支持</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon4.png" alt="" loading="lazy">
                        <p class="title-hexin">分享</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">可以将项目推进过程中重要的信息和知识分享、通告一键分享给团队所有成员，并与成员进</p>
                        <p class="p-hexin">行互相讨论。</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon5.png" alt="" loading="lazy">
                        <p class="title-hexin">智能流程</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">轻松拖拽，即可随心搭建一套业务流程，让业务的高效流转不受技术能力限制，代码真正</p>
                        <p class="p-hexin">成为坚实的底层支持，帮助业务飞速发展</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon6.png" alt="" loading="lazy">
                        <p class="title-hexin">第三方链接</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">多API接口集成，打破各平台数据壁垒，让数据无缝链接</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon7.png" alt="" loading="lazy">
                        <p class="title-hexin">扩展插件</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">多插件扩展，满足多种办公场景下的个性化需求</p>
                    </div>
                </li>
                <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon8.png" alt="" loading="lazy">
                        <p class="title-hexin">精细权限管控</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">企业部门成员可自由匹配不同权限范围，灵活适配不同的场景及业务管理需求</p>
                    </div>
                </li>
                 <li>
                    <div class="top-hexin">
                         <img src="./img-info/img-chuanyuan-icon9.png" alt="" loading="lazy">
                        <p class="title-hexin">自动化机器人</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">创造企业的机器人助手，自动完成相关流程、数据处理、预警提醒等操作，大幅减轻人力</p>
                        <p class="p-hexin">重复工作</p>
                    </div>
                </li>
                 <li>
                    <div class="top-hexin">
                        <img src="./img-info/img-chuanyuan-icon10.png" alt="" loading="lazy">
                        <p class="title-hexin">智能消息提醒</p>
                    </div>
                    <div class="bottom-hexin">
                        <p class="p-hexin">工作通知、待办、消息提醒以多种灵活渠道触达用户，可设置如定时发送、数据变动触</p>
                        <p class="p-hexin">发、第三方webhook等，建立数据时空关系</p>
                    </div>
                </li>

            </ul>
            <div class="zhuanjia">
                <p class="bushuzhuanjia">部署专家免费服务</p>
                <p class="zhuanjiafuwu"><span>联系部署专家：</span>根据您提交的需求，将有钉钉部署专家免费为您服务！</p>
                <div class="btn-zixun" @click="jumpZX">立即咨询</div>
            </div>
            <div class="sssdd"></div>
        </div>
    </div>
</template>

<script>
export default {
   methods: {
       jumpZX(){
                   window.open('https://affim.baidu.com/unique_45505196/chat?siteId=19205659&userId=45505196&siteToken=77fa0eaf9cff4d1ebd63763b42b6da96')

       }
   }
}
</script>
<style lang='less' scoped>
.zhuanshudingding{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 450px;
        background-image: url(./banner-pc-img/cpfw_cy_1920337.5@1x-tuya.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .cont1{
        width: 100%;
        .box-cont1{
            width: 80%;
            margin: 40px auto;
            background-color: rgba(255, 255, 255, 1);
           box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
            border-radius: 6px;
            padding: 40px 90px;
            .title-box{
                font-size: 30px;
                color: #000;
                line-height: 40px;
                letter-spacing: 2px;
            }
            .con-box{
                font-size: 20px;
                line-height: 25px;
                color:#696969;
                margin-top: 20px;
            }
            .ul-box{
                width: 100%;
                margin-top: 43px;
                display: flex;
                justify-content: space-between;
                li{
                    width: 30%;
                    text-align: center;
                    img{
                        width: 100%;
                         height: 250px;

                    }
                    .pp1{
                        font-size:24px;
                        color:#000000;
                        text-align: center;
                        line-height: 45px;
                        font-weight: bold;
                        letter-spacing: 2px;
                        margin-top: 10px;
                    }
                    .pp2{
                        font-size:18px;
                        color:#808080;
                        text-align: center;
                        line-height: 30px;
                    }
                }
            }
        }
        // ----
        .title-box-x{
            font-size: 35px;
            color: #000;
            text-align: center;
        }
        .jishao{
            width: 80%;
            background-color: rgb(247,247,247);
            margin: 40px auto;
            border-radius: 6px;
            padding: 10px 20px;
            display: flex;
            justify-content: space-around;
            img{
                width: 50%;
                height: 400px;
            }
            .right-jiashao{
                flex: 1;
                padding-top: 20px;
                padding-right: 15px;
                padding-left: 55px;
                .p-jiashao1{
                    font-size: 24px;
                    color: #000;
                    line-height: 33px;
                    letter-spacing: 1px;
                }
                .changjing{
                    color:#0089ff;
                    font-size: 23px;
                    line-height: 25px;
                    margin-top: 20px;
                    margin-bottom: 12px;
                }
                .one-jiaoshoa{
                    font-size: 21px;
                    line-height: 35px;
                }

            }

        }
        // ---
        .box2-cont1{
            width: 100%;
            .box2-ul{
                width: 80%;
                margin: 50px auto;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li{
                    width: 32%;
                    background-image: url("./img-info/img-chuanyuan-s5.jpg");
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    margin-bottom: 30px;
                    padding: 40px;
                    .ps1{
                        font-size: 28px;
                        font-weight: 100;
                        color: #fff;
                        text-align: center;
                        padding: 10px;
                    }
                    .lin-yuanjiao{
                        width: 50px;
                        height: 3px;
                        border-radius: 6px;
                        background-color: #fff;
                        margin: 0 auto;
                        margin-bottom: 25px;
                        margin-top: 20px;
                    }
                    .ps2{
                        font-size: 16px;
                        color:#FFFFFF;
                        text-align: center;
                        padding: 8px;
                    }
                }
            }
        }

    }
    .cont2{
        width: 100%;
        background-color: #F7F7F7;
        .miderTitles{
            font-size: 30px;
            text-align: center;
            color: #000;
            line-height: 130px;
        }
        .tuijian{
            width: 80%;
            margin: auto;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            li{
                width: 48%;
                background-color: #fff;
                transition: all 0.2s linear;
                margin-bottom: 40px;
                margin-left: 2%;
                cursor: pointer;
                .top-hexin{
                    width: 100%;
                    padding: 35px;
                    background-color: rgba(237, 240, 246, 1);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 60px;
                        height: 45px;
                        margin-top: 10px;
                    }
                    .title-hexin{
                        font-size: 22px;
                        color: #000;
                        text-align: center;
                        margin-top: 15px;
                        letter-spacing: 2px;

                    }

                }
                .bottom-hexin{
                    width: 100%;
                    background-color: #fff;
                    padding-top: 20px;
                    padding: 20px;
                    .p-hexin{
                        font-size: 18px;
                        line-height: 25px;
                        color:#696969;
                        text-align: center;
                        letter-spacing: 1px;
                    }
                }
            }
            li:hover{
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            }
        }
        .sssdd{
            height: 40px;
        }
    }
}
.miderTitle{
    font-size: 30px;
    text-align: center;
    color: #000;
    line-height: 30px;
}
.line{
   width: 30px;
    height: 2px;
    background-color: rgba(0, 137, 255, 1);
    margin: 0 auto;
    margin-top: 12px;
 }
 .letter-title{
    font-size: 16px;
    text-align: center;
   color: #000;
    line-height: 30px;
     margin-top: 15px;
}

        .zhuanjia{
            width: 80%;
             background-color: #fff;
            margin: auto;
            padding: 50px;
            position: relative;
            .bushuzhuanjia{
                font-size: 24px;
                color:#000000;
                font-weight: bold;
            }
            .zhuanjiafuwu{
                color:#696969;
                font-size: 19px;
                margin-top: 20px;
                span{
                    color:#0089ff;
                }
            }
            .btn-zixun{
                padding: 15px 40px;
                text-align: center;
                color: #fff;
                background-color: rgba(0, 137, 255, 1);
                position: absolute;
                right: 50px;
                top: 65px;
                border-radius: 4px;
                cursor: pointer;
            }
        }
</style>
